"use client"

import { useState, useEffect } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { FaGraduationCap, FaRunning, FaLeaf, FaHandsHelping, FaUserTie, FaUsers, FaImages, FaNewspaper, FaFileContract, FaHandHoldingHeart, FaEnvelope } from "react-icons/fa"
import "./Header.css"
import Logo from "../assets/Logo.jpg"
import Logo1 from "../assets/logo1.jpg"

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const isTeamActive = ["/our-team", "/committee", "/foundation-members"].includes(location.pathname)
  const isMediaActive = ["/gallery", "/articles", "/annual-reports"].includes(location.pathname)

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY
      if (offset > 50) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useEffect(() => {
    setIsMenuOpen(false)
  }, [location.pathname])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleLinkClick = (path) => {
    setIsMenuOpen(false)
    navigate(path)
    window.scrollTo(0, 0)
  }

  const handleContactClick = () => {
    setIsMenuOpen(false)
    const contactSection = document.getElementById("contact")
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div
          className="logo-section"
          onClick={() => handleLinkClick("/")}
          role="button"
          tabIndex="0"
          aria-label="Go to homepage"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleLinkClick("/")
            }
          }}
        >
          <div className="dual-logo">
            <div className="logo-wrapper">
              <img src={Logo || "/placeholder.svg"} alt="Pramila Foundation Logo" className="logo" />
            </div>
            <div className="logo-wrapper">
              <img
                src={Logo1 || "/placeholder.svg"}
                alt="Pramila Foundation Secondary Logo"
                className="logo logo-secondary"
              />
            </div>
          </div>
          <div className="logo-text">
            <h1>Pramila Foundation</h1>
            <p>Service for a Better Society</p>
          </div>
        </div>

        <button
          className={`mobile-menu-button ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav-section ${isMenuOpen ? "active" : ""}`} aria-label="Main navigation">
          <div className="nav-links">
            <Link
              to="/"
              className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
              onClick={() => handleLinkClick("/")}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`nav-link ${location.pathname === "/about" ? "active" : ""}`}
              onClick={() => handleLinkClick("/about")}
            >
              About
            </Link>
            <div className="services-dropdown">
              <button
                className={`nav-link dropdown-toggle ${isTeamActive ? "active" : ""}`}
                aria-haspopup="true"
                aria-expanded="false"
              >
                Our Team
                <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="dropdown-menu">
                <div className="dropdown-content">
                  <div className="dropdown-item">
                    <Link to="/committee" onClick={() => handleLinkClick("/committee") }>
                      <div className="service-icon team-icon">
                        <FaUserTie />
                      </div>
                      <div className="service-info">
                        <h4>Committee</h4>
                        <p>Leadership and governance</p>
                      </div>
                    </Link>
                  </div>
                  <div className="dropdown-item">
                    <Link to="/foundation-members" onClick={() => handleLinkClick("/foundation-members") }>
                      <div className="service-icon members-icon">
                        <FaUsers />
                      </div>
                      <div className="service-info">
                        <h4>Foundation Members</h4>
                        <p>Core team and supporters</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>


            <div className="services-dropdown">
              <button className="nav-link dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                Our Services
                <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="dropdown-menu">
                <div className="dropdown-content">
                  <div className="dropdown-item">
                    <Link to="/education" onClick={() => handleLinkClick("/education")}>
                      <div className="service-icon education-icon">
                        <FaGraduationCap />
                      </div>
                      <div className="service-info">
                        <h4>Education</h4>
                        <p>Quality education for all students</p>
                      </div>
                    </Link>
                  </div>
                  <div className="dropdown-item">
                    <Link to="/sports" onClick={() => handleLinkClick("/sports")}>
                      <div className="service-icon sports-icon">
                        <FaRunning />
                      </div>
                      <div className="service-info">
                        <h4>Sports</h4>
                        <p>Physical fitness and teamwork</p>
                      </div>
                    </Link>
                  </div>
                  <div className="dropdown-item">
                    <Link to="/environment" onClick={() => handleLinkClick("/environment")}>
                      <div className="service-icon environment-icon">
                        <FaLeaf />
                      </div>
                      <div className="service-info">
                        <h4>Environment</h4>
                        <p>Conservation and sustainability</p>
                      </div>
                    </Link>
                  </div>
                  <div className="dropdown-item">
                    <Link to="/welfare" onClick={() => handleLinkClick("/welfare")}>
                      <div className="service-icon welfare-icon">
                        <FaHandsHelping />
                      </div>
                      <div className="service-info">
                        <h4>Social Welfare</h4>
                        <p>Community support and care</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="services-dropdown">
              <button
                className={`nav-link dropdown-toggle ${isMediaActive ? "active" : ""}`}
                aria-haspopup="true"
                aria-expanded="false"
              >
                Media & Resources
                <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="dropdown-menu">
                <div className="dropdown-content">
                  <div className="dropdown-item">
                    <Link to="/gallery" onClick={() => handleLinkClick("/gallery") }>
                      <div className="service-icon gallery-icon">
                        <FaImages />
                      </div>
                      <div className="service-info">
                        <h4>Gallery</h4>
                        <p>Browse our photo collection</p>
                      </div>
                    </Link>
                  </div>
                  <div className="dropdown-item">
                    <Link to="/articles" onClick={() => handleLinkClick("/articles") }>
                      <div className="service-icon articles-icon">
                        <FaNewspaper />
                      </div>
                      <div className="service-info">
                        <h4>Articles</h4>
                        <p>Stories, news, and insights</p>
                      </div>
                    </Link>
                  </div>
                  <div className="dropdown-item">
                    <Link to="/annual-reports" onClick={() => handleLinkClick("/annual-reports") }>
                      <div className="service-icon reports-icon">
                        <FaFileContract />
                      </div>
                      <div className="service-info">
                        <h4>Annual Reports</h4>
                        <p>Transparency and impact reports</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="services-dropdown">
              <button className="nav-link dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                Join Us
                <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="dropdown-menu">
                <div className="dropdown-content">
                  <div className="dropdown-item">
                    <a
                      href="https://docs.google.com/forms/d/1Q9wNQuDvlwPCuad1RKvUaLd0zbpIyirZrAxXCX3iIQo/viewform?edit_requested=true"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="service-icon volunteer-icon">
                        <FaHandHoldingHeart />
                      </div>
                      <div className="service-info">
                        <h4>Volunteer</h4>
                        <p>Join our volunteer network</p>
                      </div>
                    </a>
                  </div>
                  <div className="dropdown-item">
                    <Link to="/become-member" onClick={() => handleLinkClick('/become-member')}>
                      <div className="service-icon members-icon">
                        <FaUsers />
                      </div>
                      <div className="service-info">
                        <h4>Become Member</h4>
                        <p>Register and get your member ID</p>
                      </div>
                    </Link>
                  </div>
                  <div className="dropdown-item">
                    <button type="button" className="dropdown-action" onClick={handleContactClick}>
                      <div className="service-icon contact-icon">
                        <FaEnvelope />
                      </div>
                      <div className="service-info">
                        <h4>Contact</h4>
                        <p>Reach out to the foundation</p>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  )}

export default Header
